module.exports = __webpack_public_path__ + "static/media/invest_with_confidence.9f69c17e.svg";